module.exports = ".uppercase {\n  text-transform: uppercase; }\n\n.h3 {\n  color: #17479e;\n  font-size: 25px; }\n\n.h3 .thanks {\n    font-size: 14px;\n    font-weight: bold; }\n\n.h4 {\n  color: #17479e; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pes-message/pes-message.component.scss
// module id = w7Yg
// module chunks = 1